var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifStable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6389_20730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "url(#paint0_radial_6389_20730)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6389_20730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6871 6.5372C11.5568 6.6682 11.4611 6.8275 11.406 7.00075L7.87454 16.4072H6.4502V17.85H9.14774L10.1872 14.981L10.6819 13.5388L12.4803 8.43175L15.7969 17.85H18.5496V16.4072H17.1197L13.5886 7.00045C13.5335 6.82735 13.4378 6.6681 13.3075 6.5372C13.0926 6.32125 12.8012 6.19995 12.4973 6.19995C12.1934 6.19995 11.902 6.32125 11.6871 6.5372Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6389_20730",
    x: 2.4502,
    y: 6.19995,
    width: 20.0996,
    height: 19.6499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6389_20730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6389_20730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6389_20730",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45) scale(35.3553 23.7721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFFFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616783,
    stopColor: "#1A715C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6389_20730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifStable);
export default __webpack_public_path__ + "static/media/lif-stable.1be6e113f62b7c9a8cbe4f00227f7fbf.svg";
export { ForwardRef as ReactComponent };